export const InputColor = "#E2E8F0";
export const DarkerTheme = "#08133f";
export const LightTheme = "#E9F1F6";
export const MainBlue = "#2C6FF3";
export const MainGreen = "#1DBA9E";
export const MainPink = "#F72585";
export const White = "#fff";

